module.exports = __webpack_public_path__ + "static/media/reminisce.2b37cb36.png";